import type { GetContainersParams } from 'types/api/container/containerRequests'

// What a surface hides is its own decision, never a default it inherited from the container reads.
export const EVERY_CONTAINER_ROW: GetContainersParams = {
  includePlaceholders: true,
  includeCustomerOwned: true,
}
